<form [formGroup]="baseFormGroup" class="mt-4 pl-2">
<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="IZMENIKOMITENTA.SINGULAR"></span></h2>
  </div>
</div>
<div class="modal-body">
      <div class="form-group row" >
          <div class="col-md-12">
            <yt-dropdown-picklist
            #ddlKomitent
            [ModelName]="'komitent'"
            [GetName]="'getByDrzava'"
            [GetParameters]="parameterListZaKomitente"
            [ModelProperty]="'SNaziv,Mesto'"
            [OrderBy]="'SNaziv'"
            [AllowAddNew]="true"
            [AllowEdit]="true"
            formControlName="KomitentID1"
            [Label]="'IZMENIKOMITENTA.SAKOMITENTA.SINGULAR'"
            [Width]="'xl'"
            [Position]="'left'"            
            [ngClass]="{'is-invalid': submitted && fc.KomitentID1.invalid}"
            [Disabled]="true">
           </yt-dropdown-picklist>
           <div class="form-error" *ngIf="submitted && fc.KomitentID1.invalid">
             <span *ngFor="let validation of errorMessages.KomitentID1">
               <span class="error-message" *ngIf="fc.KomitentID1.hasError(validation.type)"><span
                   translate="{{validation.message}}"></span></span>
             </span>
           </div>          
          </div>
      </div>
      <div class="form-group row" >
        <div class="col-md-12">
            <yt-dropdown-picklist
                 #ddlKomitent
                 [ModelName]="'komitent'"
                 [GetName]="'getByDrzava'"
                 [GetParameters]="parameterListZaKomitente"
                 [ModelProperty]="'SNaziv,Mesto'"
                 [OrderBy]="'SNaziv'"
                 [AllowAddNew]="true"
                 [AllowEdit]="true"
                 formControlName="KomitentID2"
                 [Label]="'IZMENIKOMITENTA.NAKOMITENTA.SINGULAR'"
                 [Width]="'xl'"
                 [Position]="'left'"                 
                 [ngClass]="{'is-invalid': submitted && fc.KomitentID2.invalid}">
                </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.KomitentID2.invalid">
                  <span *ngFor="let validation of errorMessages.KomitentID2">
                    <span class="error-message" *ngIf="fc.KomitentID2.hasError(validation.type)"><span
                        translate="{{validation.message}}"></span></span>
                  </span>
                </div>  
        </div>
      </div>
</div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span translate="FW.ACTION.SAVE.ACTION"></span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span translate="FW.ACTION.CLOSE.ACTION"></span></button>
  </div>
</form>